import { createContext } from 'react';

// =====================================================
// NGỮ CẢNH ĐĂNG NHẬP
// File: web-app/src/context/AuthContext.js
//
// ⚠️ FILE NÀY CHỈ ĐỊNH NGHĨA NGỮ CẢNH — KHÔNG CÓ PROVIDER.
//
// Provider thật nằm trong `src/App.js` (hàm App tự giữ user/permissions và
// render <AuthContext.Provider>). Trước đây ở đây có thêm một `AuthProvider`
// nữa nhưng KHÔNG AI GỌI, thành ra ai sửa nhầm vào đó thì code chạy không
// khác gì — đã mất một buổi mò vì đúng cái bẫy này (14/08/2026: thêm
// `updateUser` vào đây, build xong vẫn báo "updateUser is not a function").
//
// Muốn thêm giá trị mới vào ngữ cảnh thì sửa `src/App.js`, không phải file này.
// =====================================================

export const AuthContext = createContext({
    user: null,
    permissions: [],
    login: () => { },
    logout: () => { },
    updateUser: () => { },
    hasPermission: () => false,
    canView: () => false,
    canCreate: () => false,
    canEdit: () => false,
    canDelete: () => false,
});

export default AuthContext;
